module.exports = __webpack_public_path__ + "media/excellusbcbs-wordpress-feed@sm-972781595bd424865ac2dba76b75b963.jpg";